export const EMAIL = 'EMAIL';
export const CONVERSATIONS = 'CONVERSATIONS';
